import React, { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";

const MAX_POST = 2000;

const PostComposer = ({ topics, defaultTopic, onSubmit, submitting }) => {
  const fallback = defaultTopic && defaultTopic !== "all"
    ? defaultTopic
    : (topics?.[0]?.slug || "open");
  const [topic, setTopic] = useState(fallback);
  const [content, setContent] = useState("");

  React.useEffect(() => {
    if (defaultTopic && defaultTopic !== "all") {
      setTopic(defaultTopic);
    }
  }, [defaultTopic]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = content.trim();
    if (!trimmed) {
      toast.error("Write something before sharing.");
      return;
    }
    const ok = await onSubmit({ topic, content: trimmed });
    if (ok) {
      setContent("");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="ht-card rounded-2xl bg-white border border-[#e6eef5] p-5 sm:p-6 shadow-sm"
    >
      <div className="flex items-center gap-3">
        <p className="ht-body font-semibold text-[#2c3e50]">
          Share something quietly
        </p>
        <select
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          className="ht-input ml-auto rounded-md border border-[#dbe3eb] bg-white px-3 py-1.5 text-sm text-[#2c3e50]"
        >
          {topics.map((t) => (
            <option key={t.slug} value={t.slug}>
              {t.label}
            </option>
          ))}
        </select>
      </div>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value.slice(0, MAX_POST))}
        placeholder="Take a breath. What's on your mind today?"
        rows={4}
        className="ht-input mt-3 w-full rounded-md border border-[#d6dde4] bg-white px-3.5 py-3 text-[15px] placeholder:text-[#9aa6b2] resize-y"
      />
      <div className="mt-3 flex items-center justify-between">
        <p className="text-xs text-[#9aa6b2]">
          {content.length}/{MAX_POST} · Kind, honest, your own words.
        </p>
        <button
          type="submit"
          disabled={submitting}
          className="ht-btn inline-flex items-center gap-1.5 rounded-md bg-[#3d6486] hover:bg-[#345674] text-white font-semibold px-4 py-2 text-sm disabled:opacity-70"
        >
          <Send className="h-4 w-4" />
          {submitting ? "Sharing…" : "Share"}
        </button>
      </div>
    </form>
  );
};

export default PostComposer;
